// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Button from '../../../components/Button';
import CrossIcon from '../../../assets/images/cross-icon-white.svg';
import ExamWarningIcon from '../../../assets/images/exam-warning-icon.svg';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.31);
  `,
  SubmitContainer: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-50%,0%);
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 17px 17px 19px;
  `,
  CloseIcon: styled.img.attrs({ src: CrossIcon})`
    max-width: 11px;
    cursor: pointer;
  `,
  SubmitContent: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 39px 130px 39px 52px;
    overflow-y: auto;
    max-height: 400px;
  `,
  WarningIcon: styled.img.attrs({ src: ExamWarningIcon })`
    margin-right: 30px;
    margin-top: 10px;
  `,
  SubmitText: styled.div`
    max-width: 455px;
  `,
  TopicList: styled.ul`
    font-weight: 700;
    font-size: 28px;
    line-height: 45px;
    color: #EF8200;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  `,
  TopicListItem: styled.li`
    margin: 0 10px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 0 52px 39px 0;
  `,
  CancelButton: styled(Button)`
    background: #7A7A7A;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px 0px 0px 7px;
    padding: 4px 27px;
    margin-right: 14px;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0px 7px 7px 0px;
    padding: 4px 27px;
  `,
  TopicListTitle: styled.p`
    font-size: 18px;
    color: #EF8200;
    margin-top: 10px;
    border-bottom: 1px solid #EF8200;
  `,
  FileOverSize: styled.p`
    font-size: 18px;
    color: #EF8200;
  `,
}

const ExamPopSubmit = (props: any): JSX.Element => {
  const examList = props.examList;
  const examQAList = props.examQAList;
  const setClickSubmit = props.setClickSubmit;
  const endExam = props.endExam;
  const [fileOverSize, setFileOverSize] = useState(false);
  const undoExamList = examList.filter((item: any) => { return item.isComplete === false });
  const undoExamQAList = examQAList.filter((item: any) => { return item.isComplete === false });

  const handleClose = () => {
    setClickSubmit(false);
  }

  const handleSubmit = () => {
    endExam();
    setClickSubmit(false);
  }

  const checkFileSize = () => {
    let totalSize = 0;
    examQAList.forEach((item: any) => {
      if (item.file) {
        totalSize = totalSize + item.file.size;
      }
    })
    if (totalSize > 6*1024*1024) {
      setFileOverSize(true);
    } else {
      setFileOverSize(false);
    }
  }

  useEffect(() => {
    checkFileSize();
  }, [examQAList])

  return (
    <S.PopMask>
      <S.SubmitContainer>
        <S.CloseBar><S.CloseIcon onClick={handleClose}/></S.CloseBar>
        <S.SubmitContent>
          <S.WarningIcon/>
          { fileOverSize ? (
            <S.FileOverSize><FormattedMessage id="K038" /></S.FileOverSize>
          ) : (
            <S.SubmitText>
              { undoExamList.length === 0 && undoExamQAList.length === 0 ? (<FormattedMessage id="K012"/>):(
                <>
                  <FormattedMessage id="K013"/><br/>
                  <FormattedMessage id="K012"/>
                </>
              )}
              { undoExamList.length !== 0 ? <S.TopicListTitle>Multi Select</S.TopicListTitle> : null}
              <S.TopicList>
                { undoExamList.length !== 0 && undoExamList.map((item: any, index:number) => {
                  return (
                    <S.TopicListItem key={index}>{parseInt(item.title)+1}</S.TopicListItem>
                  )
                })}
              </S.TopicList>
              { undoExamQAList.length !== 0 ? <S.TopicListTitle>Q & A</S.TopicListTitle> : null}
              <S.TopicList>
                { undoExamQAList.length !== 0 && undoExamQAList.map((item: any, index:number) => {
                  return (
                    <S.TopicListItem key={index}>{parseInt(item.title)+1}</S.TopicListItem>
                  )
                })}
              </S.TopicList>
            </S.SubmitText>
          )}
        </S.SubmitContent>
        <S.SubmitAction>
          <S.CancelButton onClick={handleClose}><FormattedMessage id="E065" /></S.CancelButton>
          <S.SubmitButton onClick={handleSubmit} disabled={fileOverSize}><FormattedMessage id="K003" /></S.SubmitButton>
        </S.SubmitAction>
      </S.SubmitContainer>
    </S.PopMask>
  )
}

export { ExamPopSubmit as default };
